import { queryBuilder } from '@lbs/swarm-client';

export const getBetSelectionListSwarmRequest = (eventIds, gameIds) => (
    queryBuilder()
        .useSource('betting')
        .selectSport(['id', 'alias'])
        .selectRegion(['id'])
        .selectCompetition(['id'])
        .selectGame([])
        .selectMarket([])
        .selectEvent(['id', 'order', 'name', 'price', 'type', 'base', 'game_id'])
        .whereGame('id').in(gameIds)
        .whereEvent('id').in(eventIds)
        .getParams()
);

export const getBookingSelectionListSwarmRequest = (eventIds, gameIds) => (
    queryBuilder()
        .useSource("betting")
        .selectSport(["id", "alias"])
        .selectRegion(["id", "alias"])
        .selectCompetition(["id"])
        .selectGame(["id", "team1_name", "team2_name", "is_blocked", "is_live"])
        .selectMarket(["id", "name", "display_key"])
        .selectEvent(["id", "price", "name", "base", "type"])
        .whereGame("id")
        .in(gameIds)
        .whereEvent("id")
        .in(eventIds)
        .getParams()
);